<template>
  <!-- 長期不在登録画面 -->
  <v-dialog v-model="dialog" persistent max-width="650px">
    <v-container>
      <v-card>
        <v-card-title class="InsertTitle">
          <v-toolbar class="headline" color="primary" dark>{{title}}</v-toolbar>
        </v-card-title>
        <v-card-text class="cardTextStyle">
          <v-form ref="buildDialogForm" v-model="valid" lazy-validation>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="2">
                <div class="titleStyle">部屋番号</div>
              </v-col>
              <v-col cols="6">
                <ryou-input label="部屋番号" v-model="model.room_id" :value="model.room_id" :maxlength="4"
                            :disabled="true">
                </ryou-input>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="2">
                <div class="titleStyle">空室</div>
              </v-col>
              <v-col cols="6">
                <v-radio-group row v-model="roomGroup">
                  <v-radio label="空室" value="3"></v-radio>
                  <v-radio label="在室" value="0"></v-radio>
                  <v-radio label="不在" value="1"></v-radio>
                </v-radio-group>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'">
          </ryou-black-btn>
          <v-spacer></v-spacer>
          <ryou-black-btn :label="'登録'" :handlerClick="statusUpdate"></ryou-black-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
  import RyouInput from "@/components/formInput/RyouInput.vue";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  export default {
    name: "BuildingBeingStatusDialog",
    components: {
      RyouInput,
      RyouBlackBtn,
    },
    mounted() {
    },
    props: {
      loadFlag: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    data: () => ({
      dialog: false,
      valid: true,
      btnCtrl: false,
      title: "",
      roomGroup: "",
      model: {
        room_id: "",
        building_id: 0,
        loc_info: "",
      },
    }),
    methods: {
      edit(record) {
        this.open();
        this.title = "空室設定";
        this.model.building_id = record.building_id;
        this.model.room_id = record.room_id;
        this.model.loc_info = record.loc_info;

        if (this.model.loc_info == "3") {
          this.roomGroup = '3';
        } else if (this.model.loc_info == "0") {
          this.roomGroup = '0';
        } else {
          this.roomGroup = '1';
        }
        this.dialog = true;
      },
      statusUpdate() {
        this.btnCtrl = true;
        var that = this;
        let params = {
          loginUserId: this.$store.getters.getUserId,
          building_id: this.model.building_id,
          room_id: this.model.room_id,
          loc_info: this.roomGroup,
        };
        this.putRequest(
          "/buildingBeingStatusList/buildingBeingStatusUpdate",
          params,
          this.$store.getters.getUserToken
        ).then((resp) => {
          if (resp.success) {
            this.btnCtrl = false;
            that.$emit("ok");
            that.close();
          } else {
            this.btnCtrl = false;
          }
        });
      },
      handleCancel() {
        this.close();
      },
      close() {
        this.dialog = false;
        this.model.building_id = "";
        this.model.room_id = "";
        this.model.loc_info = "";
        this.roomGroup = "";
      },
      open() {
        //    this.dialog = true;
        if (this.$refs.buildDialogForm) {
          this.$refs.buildDialogForm.reset();
          this.$refs.buildDialogForm.resetValidation();
        }
      },
    },
  };
</script>

<style scoped>
  .parkselect {
    padding: 20px;
    height: 350px;
  }

  titleStyle {
    padding-top: 8%;
    text-align: center;
  }

  .btnStatus {
    width: 100px;
    height: 50px;
    outline: 1px solid lightgray;
    font-weight: 600;
  }

  .alignStyle {
    text-align: center;
  }

  .btnPadding {
    padding-top: 3%;
    white-space: nowrap;
  }

  .delBtn {
    height: 50px;
    padding-top: 10px;
  }

  .groupInput {
    height: 70px;
  }

  .btnDel {
    position: absolute;
    right: 25px;
  }

  .cardTextStyle {
    color: #000000DE !important;
    font-size: 16px !important;
  }
</style>